import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { sortBy } from 'lodash';
export const useStoreServices = (store) => {
    const [services, setServices] = useState();
    const servicesMap = {
        clickAndReserve: {
            order: 1,
            title: t('store.clickAndReserve.title'),
            desc: t('store.clickAndReserve.desc'),
        },
        clickFromStore: {
            order: 2,
            title: t('store.clickFromStore.title'),
            desc: t('store.clickFromStore.desc'),
        },
        pickUpInStore: {
            order: 3,
            title: t('store.pickUpInStore.title'),
            desc: t('store.pickUpInStore.desc'),
        },
        returnInStore: {
            order: 4,
            title: t('store.returnInStore.title'),
            desc: t('store.returnInStore.desc'),
        },
        exchangeInStore: {
            order: 5,
            title: t('store.exchangeinstore.title'),
            desc: t('store.exchangeinstore.desc'),
        },
        bookAnAppointment: {
            order: 6,
            title: t('store.bookanappointment.title'),
            desc: t('store.bookanappointment.desc'),
        },
        distantSale: {
            order: 7,
            title: t('store.distantSale.title'),
            desc: t('store.distantSale.desc'),
        },
        GarmentKit: {
            order: 8,
            title: t('store.GarmentKit.title'),
            desc: t('store.GarmentKit.desc'),
        },
        personalizationRoom: {
            order: 9,
            title: t('store.personalizationRoom.title'),
            desc: t('store.personalizationRoom.desc'),
        },
        liveBoutique: {
            order: 10,
            title: t('store.liveBoutique.title'),
            desc: t('store.liveBoutique.desc'),
        },
    };
    useEffect(() => {
        if (store === null || store === void 0 ? void 0 : store.storeServices) {
            const availableServices = store === null || store === void 0 ? void 0 : store.storeServices;
            const servicesKeys = Object.keys(availableServices);
            const arr = [];
            if (servicesKeys.length) {
                servicesKeys.map((service) => {
                    arr.push({
                        key: service,
                        title: servicesMap[service].title,
                        desc: servicesMap[service].desc,
                    });
                });
            }
            const sortedArr = sortBy(arr, (service) => servicesMap[service.key].order);
            setServices(sortedArr);
        }
    }, [store]);
    return services;
};
